export default "__VITE_ASSET__C82M1edw__"